import { components } from "../types";
import {
  getPriors,
  getQuantiles,
} from "../calls";

type FilterParams = components["schemas"]["FilterParams"];
type Quantiles = (components["schemas"]["Quantiles"] | null)[];
type Response = {
  priors: (number | null)[];
  quantiles: Quantiles;
};

/**
 * Bundled API calls for population filtering.
 * 
 * @param filter Filter parameters for population
 * @param signal Abort signal
 * @returns Filter bundle
 */
export const loadFilterBundle = async (
  filter: FilterParams,
  signal?: AbortSignal,
): Promise<Response> => {
  const [
    priors,
    quantiles,
  ] = await Promise.all([
    getPriors({filterParams: filter}, signal),
    getQuantiles({filterParams: filter}, signal),
  ]);

  return {
    priors,
    quantiles,
  };
};
